import { render, staticRenderFns } from "./ClinicsImages.vue?vue&type=template&id=3504d394&"
import script from "./ClinicsImages.vue?vue&type=script&lang=js&"
export * from "./ClinicsImages.vue?vue&type=script&lang=js&"
import style0 from "./ClinicsImages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports